import React, { useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import {
  CssBaseline,
  Box,
  Container,
  Grid,
  Typography,
  Chip,
} from "@mui/material";
import { HelmetProvider } from "react-helmet-async";
import { AnimatePresence } from "framer-motion";
import {
  Email as EmailIcon,
  Phone as PhoneIcon,
  LocationOn as LocationIcon,
} from "@mui/icons-material";
import theme from "./theme";
import Login from "./pages/auth/Login";
import Dashboard from "./pages/auth/Dashboard";
import Orders from "./pages/auth/Orders";
import ProtectedRoute from "./components/ProtectedRoute";
import Sidebar from "./components/Sidebar";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import PinCodeHistory from "./pages/auth/PinCodeHistory";
import PublicTrackOrder from "./pages/PublicTrackOrder";
import CreateOrder from "./pages/auth/CreateOrder";
import OrderDetails from "./pages/auth/OrderDetails";
import AddAddress from "./pages/AddAddress";
import Expenses from "./pages/auth/Expenses";
import Products from "./pages/auth/Products";
import AnalyticsTraffic from "./pages/auth/AnalyticsTraffic";
import Finance from "./pages/auth/Finance";

// Top bar data
const topBarData = {
  email: "ishqnamaart@gmail.com",
  phone: "+91 6393342414",
  location: "Banglore, India",
  sale: "UP TO 10% OFF - ENDS SOON!",
};

function AppContent() {
  const isAuthenticated = !!localStorage.getItem("token");
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const location = useLocation();
  const isLoginPage = location.pathname === "/" && !isAuthenticated;

  // Public pages that should not show sidebar even if authenticated
  // Note: track-order page will show sidebar if authenticated
  const isPublicPage = location.pathname === "/" ||
    location.pathname.startsWith("/add-address") ||
    location.pathname === "/track";

  // Show sidebar on authenticated pages (including track-order if authenticated)
  const shouldShowSidebar = isAuthenticated && !isPublicPage;

  const handleMenuClick = () => {
    setMobileSidebarOpen(!mobileSidebarOpen);
  };

  const handleSidebarClose = () => {
    setMobileSidebarOpen(false);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        backgroundColor: "background.default",
      }}
    >

      {shouldShowSidebar && (
        <>
          <Sidebar open={mobileSidebarOpen} onClose={handleSidebarClose} />
          <Navbar onMenuClick={handleMenuClick} />
        </>
      )}
      <Box
        sx={{
          flex: 1,
          ml: shouldShowSidebar ? { xs: 0, lg: "280px" } : 0, // Account for sidebar on desktop only when should show
          pt: shouldShowSidebar ? { xs: '56px', sm: '64px', lg: 0 } : 0, // Add top padding for navbar on mobile/tablet
          transition: "margin-left 0.3s ease, padding-top 0.3s ease",
          position: 'relative',
        }}
      >
        <AnimatePresence mode="wait">
          <Routes>
            <Route path="/" element={<Login />} />
            <Route
              path="/pincode-history"
              element={
                <ProtectedRoute>
                  <PinCodeHistory />
                </ProtectedRoute>
              }
            />
            <Route path="/track" element={<PublicTrackOrder />} />
            <Route path="/order/create" element={<ProtectedRoute><CreateOrder /></ProtectedRoute>} />
            <Route path="/order/edit/:orderId" element={<ProtectedRoute><CreateOrder /></ProtectedRoute>} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/finance"
              element={
                <ProtectedRoute>
                  <Finance />
                </ProtectedRoute>
              }
            />
            <Route
              path="/orders"
              element={
                <ProtectedRoute>
                  <Orders />
                </ProtectedRoute>
              }
            />
            <Route
              path="/expenses"
              element={
                <ProtectedRoute>
                  <Expenses />
                </ProtectedRoute>
              }
            />
            <Route
              path="/analytics-traffic"
              element={
                <ProtectedRoute>
                  <AnalyticsTraffic />
                </ProtectedRoute>
              }
            />
            <Route
              path="/products"
              element={
                <ProtectedRoute>
                  <Products />
                </ProtectedRoute>
              }
            />
            <Route
              path="/orders/:orderId"
              element={
                <ProtectedRoute>
                  <OrderDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/add-address/:orderId"
              element={<AddAddress />}
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AnimatePresence>
      </Box>
      {!isAuthenticated && !isLoginPage && <Footer />}
    </Box>
  );
}

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
          <AppContent />
        </Router>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
